// eslint-disable-next-line import/no-extraneous-dependencies
import faker from 'faker';
import { Factory } from 'miragejs';
import { v4 as uuidv4 } from 'uuid';
import { TimeUtil } from '@/util/time';

export default Factory.extend({
  provider: {
    name: 'stripe',
    instance: 'canada',
  },
  status: 'captured', // default status
  netAmount() {
    return faker.random.number({
      min: 2,
      max: 50,
    });
  },
  currency: 'cad',
  threeDS: true,
  riskScore: 1,
  providerId: uuidv4(),
  captureDate: TimeUtil.now().toISOString(),
  date: TimeUtil.now().toISOString(),
  refundDate: TimeUtil.now().toISOString(),
  refundAmount() {
    return faker.random.number({
      min: 2,
      max: 3,
    });
  },
  booking: {
    id: uuidv4(),
    fleetId: '8a7d2e09-fb66-4e3c-9cfb-09852d9abdea',
    bookingChannelId: '182e5b91-6b3a-46ef-988f-bb2f4abe7395',
    bookingChannelName() {
      return faker.company.companyName();
    },
    dispatchId() {
      return faker.random.number({
        min: 1,
        max: 1e9,
      });
    },
    amount() {
      return faker.random.number({
        min: 2,
        max: 50,
      });
    },
    paymentSource: 'APP',
  },
  payout: {
    arrivalDate: TimeUtil.now().toISOString(),
  },
  card: {
    brand() { return faker.random.arrayElement(['visa', 'mastercard', 'amex', 'jcb', 'unionpay']); },
  },
  applicationFee() {
    return faker.random.number({
      min: 0.2,
      max: 1,
    });
  },
  failureMessage: null,
  failureCode: null,
});
